import { useState } from "react";
import { Plane, Hotel, Ship } from "lucide-react";

const BRANDS = [
  { name: "Booking.com", file: "/brands/booking.svg" },
  { name: "Expedia", file: "/brands/expedia.svg" },
  { name: "RateHawk", file: "/brands/ratehawk.png" },
  { name: "Bedsonline", file: "/brands/bedsonline.png" },
  { name: "Marriott", file: "/brands/marriott.svg" },
  { name: "Hilton", file: "/brands/hilton.svg" },
  { name: "Hyatt", file: "/brands/hyatt.svg" },
  { name: "Wyndham", file: "/brands/wyndham.svg" },
  { name: "Disney", file: "/brands/disney.png" },
  { name: "Royal Caribbean", file: "/brands/royalcaribbean.svg" },
  { name: "Norwegian Cruise Line", file: "/brands/norwegian.svg" },
  { name: "Cruises.com", file: "/brands/cruises.png" },
  { name: "American Airlines", file: "/brands/american.png" },
  { name: "Delta", file: "/brands/delta.png" },
  { name: "United", file: "/brands/united.png" },
  { name: "Avianca", file: "/brands/avianca.png" },
  { name: "LATAM", file: "/brands/latam.png" },
];

const BrandLogo = ({ b }) => {
  const [err, setErr] = useState(false);
  const isText = !b.file || err;
  return (
    <div className="flex items-center justify-center h-20 sm:h-24 rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all px-5" data-testid={`home-brand-${b.name}`}>
      {isText ? (
        <span className="inline-flex items-center gap-1.5 font-black text-sm sm:text-base text-center tracking-tight" style={{ color: b.color || "#00153F" }}>
          {b.color && <Plane className="h-4 w-4 rotate-45 shrink-0" style={{ color: b.accent || b.color }} />}
          {b.name}
        </span>
      ) : (
        <img src={b.file} alt={b.name} className="max-h-10 sm:max-h-12 max-w-[150px] w-auto object-contain" loading="lazy" onError={() => setErr(true)} />
      )}
    </div>
  );
};

const BrandsStrip = () => {
  return (
    <section data-testid="home-brands-section" className="my-12">
      <div className="text-center mb-8">
        <div className="flex items-center justify-center gap-3 mb-3 text-[#1E9BE0]">
          <Plane className="h-6 w-6" /><Hotel className="h-6 w-6" /><Ship className="h-6 w-6" />
        </div>
        <h2 className="font-black text-2xl sm:text-3xl lg:text-4xl text-[#00153F] dark:text-white leading-tight" style={{ fontFamily: "Poppins, sans-serif" }}>
          Trabajamos con las compañías de viajes<br className="hidden sm:block" /> más grandes del mundo
        </h2>
        <p className="text-slate-500 dark:text-slate-400 text-base mt-3 max-w-2xl mx-auto">
          Acceso directo al mismo inventario y tarifas que usan las agencias profesionales más grandes del planeta.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {BRANDS.map((b) => <BrandLogo key={b.name} b={b} />)}
      </div>
    </section>
  );
};

export default BrandsStrip;
